import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { ListItem, ListItemText, Switch } from '@mui/material'
import { useSnackbar } from 'notistack'

import { useUpdateUserMutation } from '@/app/services/user'
import { selectCurrentUser, setCurrentUser } from '@/app/slices/appSlice'
import { showHelpWidget } from '@/common/utils'

export const UserflowHelpWidgetToggle = () => {
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    const currentUser = useSelector(selectCurrentUser)

    const [isEnabled, setIsEnabled] = useState(currentUser?.showHelpWidget)
    const dispatch = useDispatch()

    const [updateUser] = useUpdateUserMutation()

    const handleChange = async (event) => {
        const { checked } = event.target
        const user = {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName,
            language: currentUser.language,
            emailAddress: currentUser.emailAddress,
            showHelpWidget: checked,
        }
        try {
            setIsEnabled(checked)
            showHelpWidget(currentUser.userId, checked)
            const updatedUser = await updateUser({ userId: currentUser.userId, user }).unwrap()
            dispatch(setCurrentUser(updatedUser))
            enqueueSnackbar(t('Setting updated successfully.'), { variant: 'success' })
        } catch (error) {
            enqueueSnackbar(t('Could not update this setting.'), { variant: 'error', autoHideDuration: 5000 })
            setIsEnabled(!checked)
        }
    }

    return (
        <ListItem>
            <ListItemText
                id="switch-help-widget-label"
                primary={t('Show help widget')}
            />
            <Switch
                checked={isEnabled}
                edge="end"
                inputProps={{ 'aria-labelledby': 'switch-help-widget-label' }}
                size="small"
                onChange={handleChange}
            />
        </ListItem>
    )
}
